var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"top-white-box"}),_c('div',[_c('DealDetails',{attrs:{"dealId":_vm.$route.params.id}})],1),_vm._m(0),_c('Deals',{attrs:{"excludeDeal":_vm.$route.params.id,"showJoinUs":"true"}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-gray-box"},[_c('h1',[_vm._v("Other Deals You Might Like")])])
}]

export { render, staticRenderFns }